import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { MethodSection } from './components/MethodSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ModulesSection } from './components/ModulesSection';
import { EvidenceSection } from './components/EvidenceSection';
import { StorySection } from './components/StorySection';
import { FuturePacingSection } from './components/FuturePacingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ParadoxicalQuestionsSection } from './components/ParadoxicalQuestionsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
  }, []);
  return <>
      <Helmet data-id="element-0">
        <script data-id="element-1">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '867665799109515');
            fbq('track', 'PageView');
          `}
        </script>
        <noscript data-id="element-2">
          {`<img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=867665799109515&ev=PageView&noscript=1"
          />`}
        </noscript>
      </Helmet>
      <div className="w-full min-h-screen bg-white" style={{
      fontSize: '18px',
      lineHeight: 1.6,
      fontFamily: 'Inter, system-ui, sans-serif'
    }} data-id="element-3">
        <Header data-id="element-4" />
        <Hero data-id="element-5" />
        <PainSection data-id="element-6" />
        <MethodSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <ModulesSection data-id="element-9" />
        <EvidenceSection data-id="element-10" />
        <StorySection data-id="element-11" />
        <FuturePacingSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <ParadoxicalQuestionsSection data-id="element-14" />
        <PricingSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <GuaranteeSection data-id="element-17" />
        <Footer data-id="element-18" />
      </div>
    </>;
}